import * as DynaMakerContract from '../integration/DynamakerContract'

export const getItemTypeForDmItem = (item: DynaMakerContract.ItemType | 'wall'): DynaMakerContract.ItemGroup | null => {
  switch (item) {
    case 'door':
      return 'doors'
    case 'window':
      return 'windows'
    case 'garage-door':
      return 'garageDoors'
    case 'double-door':
      return 'doubleDoors'
    case 'sliding-door':
      return 'slidingDoors'
    case 'facade-section':
      return 'facadeSections'
    case 'wall':
        return null
    default:
      throw new Error(`Unexpected item in getItemTypeForDmItem: ${item}`)
  }
}
